import { useContext } from 'react';
import { SubscriptionContext } from 'contexts/subscription_context';

const useSubscription = () => {
    return useContext(SubscriptionContext);
};

export default useSubscription;
